/**
 * Created by staffanrantzow on 12/10/16.
 */

import axios from 'axios';
import CountryEntity from './country-entity';
import PendingRequestEntity from '../entities/pending-request-entity';

class CountryService {

  constructor () {
    this.countries = null;
  }

  hydrate (country) {
    return new CountryEntity(
      country.id,
      country.attributes.country_name,
      country.attributes.country_code
    );
  }

  hydrateCollection (data) {
    let countries = [];

    for (let country of data) {
      countries.push(this.hydrate(country));
    }

    return countries;
  }

  get () {
    let pendingRequest = new PendingRequestEntity();
    if (this.countries) {
      pendingRequest.promise = Promise.resolve(this.countries);
      return pendingRequest;
    } else {
      pendingRequest.promise = axios.get('backend://countries', {
        params: {
          'page[number]': 1,
          'page[size]': 250,
          'sort': 'country_name'
        },
        cancelToken: new axios.CancelToken(function executor (c) {
          pendingRequest.cancel = c;
        })
      })
        .then((response) => {
          this.countries = this.hydrateCollection(response.data.data);
          return this.countries;
        });
    }

    return pendingRequest;
  }
}

export default new CountryService();



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/countries/country-service.js
 **/